<template>
  <div :class="classes()">
    <div :class="`${el}__background`" @click="close" />
    <div :class="`${el}__content`">
      <Icon
        name="close-line"
        color="primaryBlue"
        :onClick="close"
        size="xl"
        :class="`${el}__close`"
      />
      <div ref="content" :class="`${el}__contentInner`">
        <component :is="current" :el="el" v-bind="contentSheetData" @onTrackingClick="trackClick" />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';

import { mapFieldsContentSheet, mapFieldsHealth, mapFieldsAuth } from '@/store/mapFields';
import { CONTENT_SHEET_TOOGLE } from '@/store/actions/contentSheet';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'ContentSheet',
  props: {},
  components: {
    Icon,
  },
  computed: {
    ...mapFieldsContentSheet(['contentSheetIsOpen', 'contentSheetId', 'contentSheetData']),
    ...mapFieldsHealth(['careLevel']),
    ...mapFieldsAuth(['isAuthenticated']),

    current() {
      if (this.contentSheetId) {
        return () => import(`./contents/${this.contentSheetId}`);
      }
      return () => import('./contents/Default');
    },
  },

  beforeRouteUpdate(to, from, next) {
    next((vm) => {
      vm.previousRoute = from;
    });
  },

  watch: {
    $route() {
      if (this.contentSheetIsOpen) {
        this.$store.dispatch(CONTENT_SHEET_TOOGLE);
      }
    },
    '$matchMedia.l': function () {
      this.setDocumentAttributes();
    },

    '$store.state.contentSheet.contentSheetIsOpen': function () {
      if (this.contentSheetIsOpen) {
        this.$refs.content.scrollTop = 0;
      }

      this.setDocumentAttributes();

      if (this.contentSheetIsOpen) {
        let taskType = '';
        if (this.contentSheetData && this.contentSheetData.isOptionalTask !== undefined) {
          taskType = this.contentSheetData.isOptionalTask ? '_optional' : '_obligatorisch';
        }
        this.trackClick('_open-contentsheet' + taskType, 'element');
      }
    },
  },

  data() {
    const sheetsWithSecondaryRoseLighterBackground = ['register/Index', 'register/Pgr'];

    return {
      el: 'c-contentSheet',
      previousRoute: null,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--open`]: this.contentSheetIsOpen,
          [`${el}--secondaryRoseLighter`]: sheetsWithSecondaryRoseLighterBackground.includes(
            this.contentSheetId
          ),
        };
      },
    };
  },
  methods: {
    close() {
      this.$store.dispatch(CONTENT_SHEET_TOOGLE);

      let taskType = '';

      if (this.contentSheetData && this.contentSheetData.isOptionalTask !== undefined) {
        taskType = this.contentSheetData.isOptionalTask ? '_optional' : '_obligatorisch';
      }
      this.trackClick('_close-contentsheet' + taskType, 'element');
    },

    setDocumentAttributes() {
      const { top } = document.body.getBoundingClientRect();
      const topPos = top - 56; // 56px is navBar height on mobile

      if (this.contentSheetIsOpen) {
        document.body.classList.add('no-scroll');
        if (!this.$matchMedia.l) {
          document.body.style.top = `${topPos}px`;
        } else {
          document.body.removeAttribute('style');
        }
      } else {
        document.body.classList.remove('no-scroll');
        if (!this.$matchMedia.l) {
          document.body.removeAttribute('style');
          window.scrollTo(0, top * -1);
        }
      }
    },

    trackClick(labelText, element, product = null) {
      let productLabel = '';
      let careLevelLabel = '';
      let labelAddition = '';
      let sheetType = '-Contentsheet';
      let applicationLabel = '';

      if (product !== null) {
        productLabel = product;
      }

      if (this.$route) {
        switch (this.$route.name) {
          case 'Dashboard':
            productLabel = 'Dashboard';
            break;
          case 'TaskScheduler':
            productLabel = 'Aufgabenplaner';
            break;
          case 'PflegeleistungenAnalysis':
            productLabel = 'Pflegeleistungsanalyse';
            break;
          case 'PflegeleistungenWizard':
            productLabel = 'Pflegeleistungsfinder';
            break;
          case 'CareLevelCalculatorAnalysis':
            productLabel = this.isAuthenticated ? 'Pflegegradanalyse' : 'Pflegegradrechner';
            careLevelLabel =
              this.careLevel !== null || this.careLevel >= 0 ? '-mit-PG' : '-ohne-PG';
            careLevelLabel = this.isAuthenticated
              ? careLevelLabel
              : '-redErgebnis' + careLevelLabel;
            sheetType = this.isAuthenticated ? sheetType : '-End-Content-OffCanvas';
            break;
          case 'Applications':
            applicationLabel = this.contentSheetId.replace('applications/', '');
            productLabel = `Antrag-${applicationLabel}`;
            break;
          case 'CareLevelCalculatorWizard':
            productLabel = 'Pflegegradrechner';
            break;
        }

        if (
          (this.$route.name === 'PflegeleistungenAnalysis' ||
            this.$route.name === 'PflegeleistungenWizard') &&
          !(labelText.includes('obligatorisch') || labelText.includes('optional')) &&
          (labelText.includes('open') || labelText.includes('close'))
        ) {
          labelAddition = '-click_mehr Informationen';
        }
        if (productLabel === '' && this.previousRoute) {
          productLabel = this.previousRoute;
        }
      }

      const label = productLabel + careLevelLabel + sheetType + labelText + labelAddition;

      createTrackingData(productLabel, label, element);
    },
  },
};
</script>
